import { memo } from 'react';
import { BigNumber } from 'ethers';
import { LimitBar, Skeleton, Text } from '@cronos-labs/tectonic-ui-kit';
import numbro from 'numbro';

import { formatRateToPercent } from '@lib/units';
import { getUtilizationRate } from '@lib/math';

interface AssetUtilizationProps {
  borrowAmount?: BigNumber | null;
  supplyAmount?: BigNumber | null;
}

function AssetUtilization({
  borrowAmount,
  supplyAmount,
}: AssetUtilizationProps): JSX.Element {
  if (!borrowAmount || !supplyAmount) {
    return <Skeleton />;
  }

  const rate = getUtilizationRate(borrowAmount, supplyAmount);
  return (
    <div>
      <Text className="mb-0.5">
        {numbro(rate).format({
          mantissa: 2,
          output: 'percent',
        })}
      </Text>
      <LimitBar theme="yellow" value={formatRateToPercent(rate)} />
    </div>
  );
}

export default memo(AssetUtilization);
